import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/system';

import { removeTheseProps } from '@/utils';

export type GridProps = Omit<BoxProps, 'display'> & {
  columns?: number;
  rows?: number;
};

export const Grid = styled(Box, {
  shouldForwardProp: removeTheseProps<GridProps>('columns', 'rows'),
})<GridProps>(({ columns, rows }) => ({
  display: 'grid',
  gridTemplateColumns: columns ? `repeat(${columns}, 1fr)` : 'unset',
  gridTemplateRows: rows ? `repeat(${rows}, 1fr)` : 'unset',
}));

Grid.defaultProps = {
  columns: 3,
  columnGap: 2.4,
  rows: 0,
  rowGap: 3,
};
